import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ProfileComponent } from "./profile.component";
import { NewPasswordModule } from "../../account/asset/newPassword/newPassword-form.module";

@NgModule({
    declarations: [
      ProfileComponent
    ],
    imports: [
      CommonModule,
      NewPasswordModule
    ],
    providers: [
    ]
})
export class ProfileModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/client/profile/profile.module.ts